/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SettingsImport } from './routes/settings'
import { Route as MySettingsImport } from './routes/my-settings'
import { Route as MyProfileImport } from './routes/my-profile'
import { Route as LogoutImport } from './routes/logout'
import { Route as IndexImport } from './routes/index'
import { Route as TimeIndexImport } from './routes/time/index'
import { Route as ProjectsIndexImport } from './routes/projects/index'
import { Route as ContactsIndexImport } from './routes/contacts/index'
import { Route as ClientsIndexImport } from './routes/clients/index'
import { Route as ProjectsProjectIdImport } from './routes/projects/$projectId'
import { Route as ContactsContactIdImport } from './routes/contacts/$contactId'
import { Route as ClientsClientIdImport } from './routes/clients/$clientId'
import { Route as AuthLoginImport } from './routes/auth/login'
import { Route as AuthCallbackImport } from './routes/auth/callback'

// Create/Update Routes

const SettingsRoute = SettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any)

const MySettingsRoute = MySettingsImport.update({
  id: '/my-settings',
  path: '/my-settings',
  getParentRoute: () => rootRoute,
} as any)

const MyProfileRoute = MyProfileImport.update({
  id: '/my-profile',
  path: '/my-profile',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRoute = LogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const TimeIndexRoute = TimeIndexImport.update({
  id: '/time/',
  path: '/time/',
  getParentRoute: () => rootRoute,
} as any)

const ProjectsIndexRoute = ProjectsIndexImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRoute,
} as any)

const ContactsIndexRoute = ContactsIndexImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => rootRoute,
} as any)

const ClientsIndexRoute = ClientsIndexImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => rootRoute,
} as any)

const ProjectsProjectIdRoute = ProjectsProjectIdImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRoute,
} as any)

const ContactsContactIdRoute = ContactsContactIdImport.update({
  id: '/contacts/$contactId',
  path: '/contacts/$contactId',
  getParentRoute: () => rootRoute,
} as any)

const ClientsClientIdRoute = ClientsClientIdImport.update({
  id: '/clients/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => rootRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthCallbackRoute = AuthCallbackImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/my-profile': {
      id: '/my-profile'
      path: '/my-profile'
      fullPath: '/my-profile'
      preLoaderRoute: typeof MyProfileImport
      parentRoute: typeof rootRoute
    }
    '/my-settings': {
      id: '/my-settings'
      path: '/my-settings'
      fullPath: '/my-settings'
      preLoaderRoute: typeof MySettingsImport
      parentRoute: typeof rootRoute
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsImport
      parentRoute: typeof rootRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackImport
      parentRoute: typeof rootRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/clients/$clientId': {
      id: '/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof ClientsClientIdImport
      parentRoute: typeof rootRoute
    }
    '/contacts/$contactId': {
      id: '/contacts/$contactId'
      path: '/contacts/$contactId'
      fullPath: '/contacts/$contactId'
      preLoaderRoute: typeof ContactsContactIdImport
      parentRoute: typeof rootRoute
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdImport
      parentRoute: typeof rootRoute
    }
    '/clients/': {
      id: '/clients/'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof ClientsIndexImport
      parentRoute: typeof rootRoute
    }
    '/contacts/': {
      id: '/contacts/'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof ContactsIndexImport
      parentRoute: typeof rootRoute
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsIndexImport
      parentRoute: typeof rootRoute
    }
    '/time/': {
      id: '/time/'
      path: '/time'
      fullPath: '/time'
      preLoaderRoute: typeof TimeIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/logout': typeof LogoutRoute
  '/my-profile': typeof MyProfileRoute
  '/my-settings': typeof MySettingsRoute
  '/settings': typeof SettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/contacts/$contactId': typeof ContactsContactIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/clients': typeof ClientsIndexRoute
  '/contacts': typeof ContactsIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/time': typeof TimeIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/logout': typeof LogoutRoute
  '/my-profile': typeof MyProfileRoute
  '/my-settings': typeof MySettingsRoute
  '/settings': typeof SettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/contacts/$contactId': typeof ContactsContactIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/clients': typeof ClientsIndexRoute
  '/contacts': typeof ContactsIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/time': typeof TimeIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/logout': typeof LogoutRoute
  '/my-profile': typeof MyProfileRoute
  '/my-settings': typeof MySettingsRoute
  '/settings': typeof SettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/contacts/$contactId': typeof ContactsContactIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/clients/': typeof ClientsIndexRoute
  '/contacts/': typeof ContactsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/time/': typeof TimeIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/logout'
    | '/my-profile'
    | '/my-settings'
    | '/settings'
    | '/auth/callback'
    | '/auth/login'
    | '/clients/$clientId'
    | '/contacts/$contactId'
    | '/projects/$projectId'
    | '/clients'
    | '/contacts'
    | '/projects'
    | '/time'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/logout'
    | '/my-profile'
    | '/my-settings'
    | '/settings'
    | '/auth/callback'
    | '/auth/login'
    | '/clients/$clientId'
    | '/contacts/$contactId'
    | '/projects/$projectId'
    | '/clients'
    | '/contacts'
    | '/projects'
    | '/time'
  id:
    | '__root__'
    | '/'
    | '/logout'
    | '/my-profile'
    | '/my-settings'
    | '/settings'
    | '/auth/callback'
    | '/auth/login'
    | '/clients/$clientId'
    | '/contacts/$contactId'
    | '/projects/$projectId'
    | '/clients/'
    | '/contacts/'
    | '/projects/'
    | '/time/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LogoutRoute: typeof LogoutRoute
  MyProfileRoute: typeof MyProfileRoute
  MySettingsRoute: typeof MySettingsRoute
  SettingsRoute: typeof SettingsRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthLoginRoute: typeof AuthLoginRoute
  ClientsClientIdRoute: typeof ClientsClientIdRoute
  ContactsContactIdRoute: typeof ContactsContactIdRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  ClientsIndexRoute: typeof ClientsIndexRoute
  ContactsIndexRoute: typeof ContactsIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  TimeIndexRoute: typeof TimeIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LogoutRoute: LogoutRoute,
  MyProfileRoute: MyProfileRoute,
  MySettingsRoute: MySettingsRoute,
  SettingsRoute: SettingsRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthLoginRoute: AuthLoginRoute,
  ClientsClientIdRoute: ClientsClientIdRoute,
  ContactsContactIdRoute: ContactsContactIdRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  ClientsIndexRoute: ClientsIndexRoute,
  ContactsIndexRoute: ContactsIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  TimeIndexRoute: TimeIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/logout",
        "/my-profile",
        "/my-settings",
        "/settings",
        "/auth/callback",
        "/auth/login",
        "/clients/$clientId",
        "/contacts/$contactId",
        "/projects/$projectId",
        "/clients/",
        "/contacts/",
        "/projects/",
        "/time/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/my-profile": {
      "filePath": "my-profile.tsx"
    },
    "/my-settings": {
      "filePath": "my-settings.tsx"
    },
    "/settings": {
      "filePath": "settings.tsx"
    },
    "/auth/callback": {
      "filePath": "auth/callback.tsx"
    },
    "/auth/login": {
      "filePath": "auth/login.tsx"
    },
    "/clients/$clientId": {
      "filePath": "clients/$clientId.tsx"
    },
    "/contacts/$contactId": {
      "filePath": "contacts/$contactId.tsx"
    },
    "/projects/$projectId": {
      "filePath": "projects/$projectId.tsx"
    },
    "/clients/": {
      "filePath": "clients/index.tsx"
    },
    "/contacts/": {
      "filePath": "contacts/index.tsx"
    },
    "/projects/": {
      "filePath": "projects/index.tsx"
    },
    "/time/": {
      "filePath": "time/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
